import React, { Component } from 'react';
import { BrowserRouter, Route, Switch } from 'react-router-dom';

import AdminLogin from './AdminLogin/AdminLogin';
import AdminDashboard from './AdminDashboard/AdminDashboard';
import AdminGuests from './AdminGuests/AdminGuests';
import AdminEvent from './AdminEvent/AdminEvent';
import AdminInventory from './AdminInventory/AdminInventory';
import AdminCommunication from './AdminCommunication/AdminCommunication';
import AdminViewEmail from './AdminCommunication/AdminViewEmail';
import AdminUserManagement from './AdminUserManagement/AdminUserManagement';
import AdminMultilang from './AdminMultilang/AdminMultilang';
import AdminReports from './AdminReports/AdminReports';
import AdminSettings from './AdminSettings/AdminSettings';

import './styles/styles.scss';

import adminStore from './redux/adminStore';
import { Provider } from "react-redux";
import AdminLoader from "./AdminLoader";
import AdminRoute from "./AdminRoute";
import 'react-dates/initialize';
import { DndProvider } from 'react-dnd'
import { HTML5Backend } from 'react-dnd-html5-backend'
import AdminMultiEvent from './AdminMultiEvent/AdminMultiEvent';
import { ToastContainer } from 'react-toastify';

class Admin extends Component {

    constructor(props, context) {
        super(props, context);
    }

    render() {
        return (
            <Provider store={adminStore}>
                <DndProvider backend={HTML5Backend}>
                    <AdminLoader>
                        <BrowserRouter basename={'/admin'}>
                            <Switch>
                                <Route exact path='/login' component={AdminLogin} />
                                <AdminRoute exact path='/' component={AdminMultiEvent} />
                                <AdminRoute exact path='/dashboard' component={AdminDashboard} />
                                <AdminRoute path='/event' component={AdminEvent} />
                                <AdminRoute path='/guests' component={AdminGuests} />
                                <AdminRoute path='/inventory' component={AdminInventory} />
                                <AdminRoute exact path='/communication' component={AdminCommunication} />
                                <AdminRoute exact path='/communication/:id(\d+)' component={AdminViewEmail} />
                                <AdminRoute path='/reports' component={AdminReports} />
                                <AdminRoute path='/users' component={AdminUserManagement} />
                                <AdminRoute path='/multilang' component={AdminMultilang} />
                                <AdminRoute path='/settings' component={AdminSettings} />
                            </Switch>
                            <ToastContainer position="bottom-right" autoClose={3000} />
                        </BrowserRouter>
                    </AdminLoader>
                </DndProvider>
            </Provider>
        );
    }
}

export default Admin;
